import { GridColDef } from '@mui/x-data-grid';
import MuiDataGrid from 'components/MuiDataGrid';
import useI18n from 'hooks/useI18n';
import { TGender, TPublic } from './api/type';
import { IAdminPatients } from './api/type';

interface Props {
  list: IAdminPatients[];
  isLoading: boolean;
  totalCount: number;
  page: number;
  selected: string[];
  onSelected: (value: string[]) => void;
  onPageChange: (page: number) => void;
}

function ListBody(props: Props) {
  const i18n = useI18n();
  const {
    list,
    isLoading,
    totalCount,
    page,
    onPageChange,
    onSelected,
    selected,
  } = props;

  const columns: GridColDef[] = [
    { field: 'patient_id', headerName: 'Virtual Patient ID' },
    { field: 'name', headerName: 'Virtual Patient Name', minWidth: 200 },
    { field: 'age', headerName: 'Age' },
    {
      field: 'gender',
      headerName: 'Gender',
      valueFormatter: ({ value }: { value: TGender }) =>
        i18n(`GENDER.${value}`),
    },
    { field: 'department', headerName: 'Department' },
    { field: 'ward', headerName: 'Ward' },
    { field: 'disease_main', headerName: 'Main Diagnosis Code' },
    {
      field: 'patient_private',
      headerName: 'Student ENR Visibility',
      valueFormatter: ({ value }: { value: TPublic }) =>
        i18n(`PUBLIC.${value}`),
    },
  ];

  return (
    <MuiDataGrid
      columns={columns}
      loading={isLoading}
      onPageChange={onPageChange}
      onSelectionModelChange={models => {
        onSelected(models as string[]);
      }}
      page={page}
      pageSize={20}
      rows={list.map(item => ({ ...item, id: item.patient_id }))}
      rowCount={totalCount}
      selectionModel={selected}
    />
  );
}

export default ListBody;
